<script lang="ts" setup>
defineOgImageComponent('OgBase')
</script>

<template>
  <LandingPage />
</template>
